/**
 * Hook for IFS user details (Redux). Use this or IfsUserContext to read/fetch/clear IFS user.
 */
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchIfsUserDetails, clearIfsUser } from "../slices/ifsUser";

export function useIfsUser() {
  const dispatch = useAppDispatch();
  const { user: ifsUser, status, error } = useAppSelector((state) => state.IfsUser ?? {});

  const loadIfsUserDetails = useCallback(() => dispatch(fetchIfsUserDetails()), [dispatch]);
  const clear = useCallback(() => dispatch(clearIfsUser()), [dispatch]);

  return {
    ifsUser: ifsUser ?? null,
    loading: status === "loading",
    error: error ?? null,
    isSucceeded: status === "succeeded",
    isFailed: status === "failed",
    fetchIfsUserDetails: loadIfsUserDetails,
    clearIfsUser: clear,
  };
}
